import { gql } from '@apollo/client'

export const FEEDBACKS_EXPORT_TASKS_QUERY = gql`
  query feedbacksExportTasks(
    $sortBy: FeedbacksExportTaskSort
    $filter: FeedbacksExportTaskFilter
    $limit: Int
  ) {
    feedbacksExportTasks(sortBy: $sortBy, filter: $filter, limit: $limit) {
      collection {
        id
        createdAt
        hasDownloaded
        documentUrl
        hasErrors
        userId
        status
      }
    }
  }
`
